import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import ConversationList from '../components/messages/ConversationList';
import ChatWindow from '../components/messages/ChatWindow';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { connectSocket, disconnectSocket } from '../services/socketService';

const MessagesPage: React.FC = () => {
    const { user, isLoading: isAuthLoading } = useAuth();
    const location = useLocation();
    
    const initialTargetUserId = location.state?.targetUserId || null;
    const initialTargetUserName = location.state?.targetUserName || null;

    const initialConversationId = location.state?.conversationId || null;
    const [selectedConversationId, setSelectedConversationId] = useState<number | null>(initialConversationId);

    const [targetUser, setTargetUser] = useState<{ id: number; name: string | null } | null>(
        initialTargetUserId ? { id: initialTargetUserId, name: initialTargetUserName } : null
    );

    useEffect(() => {
        if (location.state?.targetUserId || location.state?.conversationId) {
            window.history.replaceState({}, '');
        }
    }, [location.state]);

    useEffect(() => {
        let token = localStorage.getItem('token');
        
        if (user && token) {
            console.log('MessagesPage mounted/user changed, connecting socket...');
            connectSocket(token);
        } else {
            console.log('MessagesPage mounted/user changed, ensuring socket is disconnected...');
            disconnectSocket();
        }

        return () => {
            console.log('MessagesPage unmounting/cleanup, disconnecting socket...');
            disconnectSocket();
        };
    }, [user]);

    const handleSelectConversation = (conversationId: number) => {
        setSelectedConversationId(conversationId);
        setTargetUser(null);
    };

    if (isAuthLoading) {
        return <LoadingSpinner text="Loading user..." />;
    }

    if (!user) {
        return <p className="text-center py-5">Please log in to view messages.</p>;
    }

    return (
        <Container fluid className="messages-page-container d-flex flex-column pt-3">
            <Row className="g-0 flex-grow-1">
                <Col xs={12} sm={4} lg={3} className="border-end conversation-list-col d-flex flex-column">
                    <h4 className="px-3 py-2 mb-0 border-bottom">Conversations</h4>
                    <div className="flex-grow-1 overflow-auto">
                        <ConversationList 
                            selectedConversationId={selectedConversationId}
                            onSelectConversation={handleSelectConversation} 
                            initialTargetUserId={targetUser?.id}
                            initialTargetUserName={targetUser?.name}
                        />
                    </div>
                </Col>

                <Col xs={12} sm={8} lg={9} className="d-flex flex-column chat-window-col">
                    {selectedConversationId ? (
                        <ChatWindow 
                            selectedConversationId={selectedConversationId} 
                        />
                    ) : (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <p className="text-muted">Select a conversation to start chatting</p>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default MessagesPage;
